/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { useState } from "react";
import { useContext } from "../../../context";
import { uiNotification } from "../../../../../../../../../services/UINotificationService";
import { useUpdateAdditionalProvider } from "../../../hooks/useUpdateAdditionalProvider";

export function AdditionalProvider() {
  const { appointment, selectedAdditionalProvider, selectedProvider } =
    useContext();

  const updateProvider = useUpdateAdditionalProvider();

  const [showEdit, setShowEdit] = useState(false);

  const onUpdate = () => {
    if (!selectedAdditionalProvider.value) {
      return uiNotification.error("Please select an additional provider.");
    }
    updateProvider
      .initiate({
        providerId: Number(selectedAdditionalProvider.value),
      })
      .then(() => {
        setShowEdit(false);
        selectedAdditionalProvider.setValue(0);
      });
  };

  return (
    <div>
      <div className="detail-row">
        <label>Additional Provider:</label>
        <span className="editEventCalNote">
          {appointment.additionalProvider?.name}
          {showEdit && (
            <select
              className="simpleSelect"
              name="appointment_additional_provider"
              onChange={(e) =>
                selectedAdditionalProvider.setValue(Number(e.target.value))
              }
              value={selectedAdditionalProvider.value}
            >
              <option value="0">Select</option>
              {appointment.providersForChange
                .filter((x) => String(x.id) !== String(selectedProvider.value))
                .map((obj, idx) => (
                  <option key={idx} value={obj.id}>
                    {obj.fullName}
                  </option>
                ))}
            </select>
          )}
          {!appointment.isAdditionalProviderAppointment && (
            <a onClick={() => setShowEdit(true)}>
              <i className="far fa-edit"></i>
            </a>
          )}
        </span>
      </div>
      {showEdit && (
        <div className="deatil-row appointNoteBtn d-flex justify-end">
          <span>
            <button
              className="new-white-btn no-width"
              onClick={() => {
                setShowEdit(false);
                selectedAdditionalProvider.setValue(0);
              }}
            >
              Cancel
            </button>
            <button
              className="new-blue-btn no-width"
              onClick={onUpdate}
              disabled={updateProvider.isLoading}
            >
              {updateProvider.isLoading ? "Saving..." : "Save"}
            </button>
          </span>
        </div>
      )}
    </div>
  );
}
